export default {
  "header": {
    "CHANGE_PASSWORD": "Change Password",
    "CHANGE_STATION": "Change Station ID",
    "CHANGE_SETTING": "Settings",
    "CLICK_ON": "Click on",
    "CLICK_ON_THE_FOLD": "Click on the fold",
    "CURRENT_PASSWORD": "Current Password",
    "FAILED_UPDATE_TASK_LIST": "Failed to update task list",
    "LOGOUT": "Logout",
    "MSG_ENTER_CURRENT_PASSWORD": "Please enter current password",
    "MSG_ENTER_NEW_PASSWORD": "Please enter new password",
    "MSG_NEW_PASSWORD_NOT_MATCH": "New password is not match",
    "MSG_PASSWORD_UPDATED": "Your password is updated successfully, please login with new password.",
    "NEW_PASSWORD": "New Password",
    "NEW_PASSWORD_AGAIN": "New Password Again",
    "SELECT_CLIENT_TO_SWITCH": "Select Client to Switch",
    "SWITCH_CLIENT": "Switch Client",
    "SWITCHED_TO_CLIENT": "Switched to Client",
    "TASK_LIST": "Task List",
    "UPDATE_PASSWORD": "Update Password",
    "USER_PROFILE": "User Profile",
    "DIM_WEIGHT_ADDRESS": "Dim Weight Address",
    "MSG_SETTING_UPDATED_SUCCESS": "Setting saved, please refresh page to apply changes.",
    "WEIGHT_MODE": "Weight Mode",
    "WEIGHT_MODE_NONE": "None (Manual)",
    "WEIGHT_MODE_LOCAL": "Local (WebApp Hardware Bridge)",
    "WEIGHT_MODE_DIM_WEIGHT": "Dim Weight Machine (Network)",
    "SAVE": "Save"
  },
  "login": {
    "EMAIL": "Email",
    "ERROR_EMPTY_PASSWORD": "Password cannot be empty",
    "INFO_LOGIN_SUCCESS": "Login Success",
    "LOGIN_INCORRECT": "Invalid login, could be wrong username or password",
    "MFA_CODE": "MFA Code",
    "MFA_INVALID": "Invalid MFA Code, please double confirm and submit again",
    "MFA_REQUIRED": "MFA Code required, please receive it from SMS or OTP via registered mobile phone",
    "PASSWORD": "Password",
    "RESET": "Reset",
    "SUBMIT": "Login",
    "SWITCHING_CLIENT": "Switching client, please wait ...",
    "USERNAME": "Username"
  },
  "menu": {
    "DASHBOARD": "Dashboard",
    "INBOUND_AND_OUTBOUND": "Today In & Out",
    "MANUAL_SORTING": "Manual sorting",
    "OPERATION_INBOUND": "Inbound",
    "OPERATION_MANUAL_SORT": "Manual Sort",
    "OPERATION_LOCKER_RETURN_INBOUND": "Locker Return Inbound",
    "DEST_PICKUP_INBOUND":"Destination Pick-up Inbound",
    "PY_RETURN_INBOUND":"PY Return Inbound",
    "OPERATION_MANUAL_OUTBOUND": "Manual Outbound",
    "OPERATION_MANUAL_CLOSE_BOX": "Close Box and Create H/O",
    "OPERATION_OUTBOUND": "Outbound",
    "OPERATION_RETURN": "Return",
    "PROBLEM_WAREHOUSE":'Problem',
    "OPERATION_CONSOLIDATION": "Consolidation",
    "OPERATION_CHECK": "Check Order",
    "VOLUME_BY_SORT_CODE": "Volume by Route",
    "AUTO_SORTER": "Auto Sorter",
    "AUTO_SORTER_DASHBOARD": "Dashboard",
    "AUTO_SORTER_CONTROL_PANEL": "Control Panel",
    "AUTO_SORTER_PROFILES": "Profiles",
    "DHL_ITEM_SORTING":"DHL Sorting",
    "INBOUND_PACKAGE_HANDING":"Inbound Parcel",
    "COLLECTION":"Pick Up Parcel",
    "PY_SORT_INBOUND":"PY Inbound",
    "HANDOVER_REPORT":"Report",
    "ORDERINFO":"Order Info "

  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js